import { install } from '@attendu/email-components';
import '@attendu/email-components/dist/email-components.css';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(install);
});
